import { render } from "./Alergia_AlergiaPers.vue?vue&type=template&id=05b619e6"
import script from "./Alergia_AlergiaPers.vue?vue&type=script&lang=js"
export * from "./Alergia_AlergiaPers.vue?vue&type=script&lang=js"

import "./Alergia_AlergiaPers.vue?vue&type=style&index=0&id=05b619e6&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__